// import setup methods
import setupVue from './vue';
import setupElementUI from './element-ui';
import setupComponents from './components';
import setupVueResource from './vue-resource';
import setupBroadcasting from './broadcasting';
import setupBugsnag from './bugsnag';
import setupSentry from './sentry';
import setupAnalytics from './analytics';

/**
 * Setup the application
 */
export default function (rootComponent = {}) {
    const Vue = setupVue(rootComponent);

    setupBugsnag(Vue);
    setupSentry(Vue);
    setupAnalytics();
    setupBroadcasting();
    setupElementUI(Vue);
    setupComponents(Vue);
    setupVueResource(Vue);

    return Vue;
}
